import React from 'react';
import Peel from './peel';
import './pick.css';
import {makeStyles, createStyles, useTheme} from '@material-ui/core/styles';
import {IconButton, useMediaQuery} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import ReactResizeDetector from 'react-resize-detector';
import {formatDate} from '../../utils/index';
import {isSafari} from 'react-device-detect';
import LazyImage from '../App/LazyImage';
import { shadow_pick_path } from '../../var'

const useStyles = makeStyles((theme) =>
    createStyles({
        videoPlayButton: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            zIndex: 2,
        },
        videoPlayButtonIcon: {
            textShadow: '0 1px 4px rgba(0,0,0,0.4)',
            filter: 'drop-shadow( 0px 0px 1px rgba(0, 0, 0))',
            '&:hover': {
                textShadow: '0 1px 4px rgba(0,0,0,0.4)',
            },
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.text.primary,
            zIndex: 1,
        },
        pickWrapper: {
            maxWidth: '300px',
            margin: 'auto',
            width: '100%',
            maxHeight: '100%',
        },
        peelTopHidden: {
            visibility: 'hidden',
        },
        peelBottomHidden: {
            visibility: 'hidden',
        },
        peelBackHidden: {
            visibility: 'hidden',
        },
        swipeToOpenHidden: {
            visibility: 'hidden',
        },
        peelBottomShadowHidden: {
            '& .peel-bottom-shadow': {
                visibility: 'hidden',
            },
        },
        peelShadowHidden: {
            '& svg.peel-layer': {
                display: 'none !important',
            },
        },
    })
);

const Pick = function ({
    gift,
    pickImageRef = null,
    handleUnsizedPickImage = false,
    sendUnwrapEvent = false,
    ...props
}) {
    const theme = useTheme();
    const classes = useStyles();
    const transparentGifSrc =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    const [uniqueId, setUniqueId] = React.useState(
        Math.floor(Math.random() * 1000000000)
    );
    const videoRef = React.useRef(null);
    const peelRef = React.useRef(null);
    const wrapperImageRef = React.useRef(null);
    const pickRef = React.useRef(null);
    const videoPlayInterval = React.useRef(null);
    const teaseInterval = React.useRef(null);
    const autoOpenInterval = React.useRef(null);
    const videoSourceRef = React.useRef(null);
    const [pickPreviewOpen, setPickPreviewOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [unwrapEventSent, setUnwrapEventSent] = React.useState(false);
    const [resizePickImageMaxDimension, setResizePickImageMaxDimension] =
        React.useState('maxWidth');
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    const pickWrapperRef = React.useRef();
    const [visibility, setVisibility] = React.useState('hidden');
    const [wrapperLoaded, setWrapperLoaded] = React.useState(false);
    const [resetReady, setResetReady] = React.useState(false);
    const [initReady, setInitReady] = React.useState(false);
    const [resizeReady, setResizeReady] = React.useState(false);

    let p = React.useRef(),
        willTease = props.tease,
        dragged = false,
        isOpening = false,
        peelSpeed = 1,
        path,
        pickWrapper = transparentGifSrc,
        pickImage = transparentGifSrc,
        peelClasses = ['peel', 'peel--has-wrapper', 'peel--has-image'];

    if (props.pickWrapper) {
        pickWrapper = props.pickWrapper;
    }
    if (props.pickImage) {
        pickImage = props.pickImage;
    }

    React.useEffect(() => {
        if (props.autoOpen) {
            window.setTimeout(() => {
                clearInterval(teaseInterval.current);
                // eslint-disable-next-line
                isOpening = true;
                // eslint-disable-next-line
                peelSpeed = 10;
                peelOpen();
            }, props.autoOpenDelay || 0);
        }

        return () => {
            clearInterval(teaseInterval.current);
            clearInterval(autoOpenInterval.current);
        };
        // eslint-disable-next-line
    }, [props.autoOpen]);

    const resize = () => {
        const pickWrapperHeight = pickWrapperRef.current.offsetHeight;
        const pickWrapperWidth = pickWrapperRef.current.offsetWidth;
        const ratio = pickWrapperWidth / pickWrapperHeight;

        if (ratio > 1.23026315789) {
            pickWrapperRef.current.style.width = `${
                1.23026315789 * pickWrapperHeight
            }px`;
        }
        setResizeReady(true);
    };

    React.useEffect(() => {
        // const timeoutFn = () => {
        //     if (pickRef.current) {
        //         reset();
        //         return;
        //     }
        //     setTimeout(timeoutFn, 200);
        // };
        // setTimeout(timeoutFn, 200);
        // eslint-disable-next-line
    }, [props.pickWrapper, props.pickImage]);

    const reset = function () {
        if (!pickRef.current) {
            return;
        }
        setOpen(false);
        setUniqueId(Math.floor(Math.random() * 1000000000));

        resize();

        let width = pickRef.current.offsetWidth;
        let height = pickRef.current.offsetHeight;

        willTease = props.tease;
        dragged = false;
        if (props.pickWrapper) {
            if (!willTease) {
                p.current.setPeelPosition(width / 3, height / 2);
            }
        }
        setResetReady(true);
        // p.current.el.remove();
        // p.current.topClip.el.remove();
        // p.current.topShapeClip.el.remove();
        // p.current.topLayer.remove();
        // p.current.backClip.el.remove();
        // p.current.topShadowElement.remove();
    };
    React.useEffect(() => {
        if (
            resetReady &&
            wrapperLoaded &&
            pickWrapper &&
            initReady &&
            resizeReady
        ) {
            setVisibility('visible');
        }
    }, [resetReady, wrapperLoaded, pickWrapper, initReady, resizeReady]);

    const peelOpen = () => {
        if (p && pickRef.current) {
            const width = pickRef.current.offsetWidth;
            dragged = true;
            let left = p.current.getPeelPosition().x;
            autoOpenInterval.current = setInterval(() => {
                p.current.setPeelPosition(left, p.current.getPeelPosition().y);
                pickRef.current.style.opacity = pickRef.current.style.opacity === '0.999' ? 1 : 0.999;
                left = left + 3;
                if (left > width * 2.2) {
                    clearInterval(autoOpenInterval.current);
                    isOpening = false;
                    setOpen(true);
                }
            }, peelSpeed);
        }
    };
    const tease = function () {
        let i = 0,
            height = pickRef.current.offsetHeight / 2,
            rightHandBreak = pickRef.current.offsetWidth / 3,
            leftHandBreak = pickRef.current.offsetWidth / 6,
            dir;

        willTease = false;
        clearInterval(teaseInterval.current);
        teaseInterval.current = setInterval(function () {
            if (i > rightHandBreak) {
                dir = -1;
            }
            if (i <= leftHandBreak) {
                dir = 1;
            }
            i = i + dir;
            if (!dragged) {
                pickRef.current.style.opacity = pickRef.current.style.opacity === '0.999' ? 1 : 0.999;
                p.current.setPeelPosition(i, height);
            }
        }, (400 / pickRef.current.offsetWidth) * 15);
    };
    const handlePreviewPlayButton = () => {
        setPickPreviewOpen(true);
        if (videoPlayInterval.current) {
            return;
        }
        videoPlayInterval.current = setInterval(() => {
            if (videoRef.current && videoRef.current.readyState === 4) {
                videoRef.current.play();
                clearInterval(videoPlayInterval.current);
            }
        }, 200);
    };
    const init = () => {
        const width = pickRef.current.offsetWidth - 1;
        const height = pickRef.current.offsetHeight;
        // const width = 300;
        // const height = 262;

        const var1 = 0.5;
        const var2 = 0.361;
        const var3 = -0.540;
        const var4 = 0.5;
        const var5 = 1.53;
        const var6 = 0.660;
        const var7 = 0.5;

        path = `M0 ${var1 * height} C 0 ${Math.round(
            var2 * height
        )}, ${width} ${Math.round(var3 * height)}, ${width} ${Math.round(
            var4 * height
        )} C ${width} ${Math.round(var5 * height)}, 0 ${Math.round(
            var6 * height
        )}, 0 ${var7 * height}`;

        window.pickPathReverse = `M0 ${0.5 * height} C 0 ${Math.round(
            var3 * height
        )}, ${width} ${Math.round(var2 * height)}, ${width} ${Math.round(
            var4 * height
        )} C ${width} ${Math.round(var6 * height)}, 0 ${Math.round(
            var5 * height
        )}, 0 ${var1 * height}`;

        p.current = new Peel(peelRef.current, {
            topShadow: true,
            backShadowSize: 0.2,
            backShadowAlpha: 0.3,
            backReflection: true,
            backReflectionAlpha: 0.1,
            topShadowCreatesShape: true,
            dragPreventsDefault: false,
            path: {
                d: path,
            },
        });

        p.current.setCorner(0, height / 2);
        p.current.setFadeThreshold(0.8);
        p.current.setPeelPosition(0, height / 2);

        if (props.pickWrapper) {
            p.current.handleDrag(function (evt, x, y) {

                pickRef.current.style.opacity = pickRef.current.style.opacity === '0.999' ? 1 : 0.999;
                // eslint-disable-next-line
                const offsetHeight = pickRef.current.offsetHeight;

                if (isOpening) {
                    return;
                }
                dragged = true;
                const xPos =
                    typeof evt.pageX !== 'undefined'
                        ? evt.pageX
                        : evt.touches[0].pageX;
                const yPos =
                    typeof evt.pageY !== 'undefined'
                        ? evt.pageY
                        : evt.touches[0].pageY;
                const offsetX = Math.max(
                    0,
                    xPos - peelRef.current.getBoundingClientRect().left
                );
                const offsetY =
                    yPos -
                    peelRef.current.getBoundingClientRect().top -
                    window.pageYOffset;
                const breakpoint = (peelRef.current.offsetWidth * 9) / 10;
                if (offsetX > breakpoint) {
                    isOpening = true;
                    peelOpen();
                } else {
                    this.setPeelPosition(offsetX, offsetY);
                    setOpen(false);
                }
            });
            if (!willTease) {
                p.current.setPeelPosition(width / 3, height / 2);
            }
        }

        if (willTease) {
            tease();
        }

        setInitReady(true);
    };

    React.useEffect(() => {
        if (open && !unwrapEventSent) {
            setUnwrapEventSent(true);
            if (sendUnwrapEvent) {
                // this is needed until all <Pick/> are started from React
                const recipientGuid = gift.guid
                    ? gift.guid
                    : props.recipientGuid;
                const senderGuid = gift.sender_guid
                    ? gift.sender_guid
                    : props.senderGuid;
                const giftId = gift.id ? gift.id : props.giftId;
                const dateAvailable = gift.date_available
                    ? formatDate(gift.date_available)
                    : props.dateAvailable;
                const wrappingImageCustomized = gift.wrapping_image_customized
                    ? gift.wrapping_image_customized
                    : props.wrappingImageCustomized;
                const paidMerchant = gift.paid_merchant
                    ? gift.paid_merchant
                    : props.paidMerchant;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'unwrapGiftYa',
                    senderGuid: senderGuid,
                    giftId: giftId,
                    giftSendDate: dateAvailable,
                    guid: recipientGuid,
                    wrapType: wrappingImageCustomized ? 'custom' : 'predesign',
                    branded: paidMerchant ? 'branded' : 'nonbranded',
                });
            }
        }

        // eslint-disable-next-line
    }, [open]);

    // React.useEffect(init, []);

    React.useEffect(init, [uniqueId]);

    React.useEffect(reset, [props.pickWrapper, props.pickImage, wrapperLoaded]);

    React.useEffect(() => {
        if (pickImageRef && pickImageRef.current && handleUnsizedPickImage) {
            const ratio =
                pickImageRef.current.offsetWidth /
                pickImageRef.current.offsetHeight;
            setResizePickImageMaxDimension(
                ratio > 0.81333 ? 'maxHeight' : 'maxWidth'
            );
        }
    }, [pickImageRef, handleUnsizedPickImage]);

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    };

    const handlePickImageClick = (evt) => {
        const xPos =
            typeof evt.pageX !== 'undefined' ? evt.pageX : evt.touches[0].pageX;
        const yPos =
            typeof evt.pageY !== 'undefined' ? evt.pageY : evt.touches[0].pageY;
        const offsetX = Math.max(
            0,
            xPos - peelRef.current.getBoundingClientRect().left
        );
        const offsetY =
            yPos -
            peelRef.current.getBoundingClientRect().top -
            window.pageYOffset;
        p.current.setPeelPosition(offsetX, offsetY);
    };

    return (
        <ReactResizeDetector handleWidth handleHeight onResize={reset} refreshMode="throttle">
            <div
                key={uniqueId}
                ref={pickWrapperRef}
                className={classes.pickWrapper}
                style={{visibility}}>
                <div className="pick" ref={pickRef} onClick={handleClick}>
                    <img
                        alt="Swipe to Open"
                        className={clsx('swipe-to-open-graphic', {
                            [classes.swipeToOpenHidden]:
                                !props.swipeToOpen || open,
                        })}
                        src={`https://d2kn7nb9ubajli.cloudfront.net/pick/swipe-to-open${
                            !props.darkBackground ? '-dark-grey' : ''
                        }.png`}
                    />

                    <div ref={peelRef} className={peelClasses.join(' ')}>
                        <svg className="shadow" viewBox="0 0 300 262">
                            <path d={shadow_pick_path} fill="#BDBDBD" />
                        </svg>
                        <div
                            className={clsx('peel-top', {
                                [classes.peelTopHidden]: !props.pickWrapper,
                                [classes.peelShadowHidden]: isSafari,
                            })}>
                            {props.video && (
                                <div>
                                    <div
                                        onClick={handlePreviewPlayButton}
                                        className={classes.videoPlayButton}>
                                        <PlayCircleOutlineIcon
                                            className={
                                                classes.videoPlayButtonIcon
                                            }
                                            style={{
                                                fontSize: xsOnly
                                                    ? '50px'
                                                    : '60px',
                                            }}
                                        />
                                    </div>
                                    <Dialog
                                        PaperProps={{
                                            style: {backgroundColor: 'white'},
                                        }}
                                        onClose={() => {
                                            setPickPreviewOpen(false);
                                        }}
                                        open={pickPreviewOpen}>
                                        <IconButton
                                            className={classes.closeButton}
                                            aria-label="close"
                                            onClick={() => {
                                                setPickPreviewOpen(false);
                                            }}>
                                            <CloseIcon />
                                        </IconButton>
                                        <video
                                            style={{maxHeight: '90vh'}}
                                            ref={videoRef}
                                            controls
                                            playsInline>
                                            <source
                                                ref={videoSourceRef}
                                                src={props.video}
                                            />
                                        </video>
                                    </Dialog>
                                </div>
                            )}
                            <div className="pick__wrapper">
                                <span className="pick__wrapper-layer">
                                    <img
                                        draggable="false"
                                        ref={wrapperImageRef}
                                        alt="GiftYa wrapper"
                                        onLoad={() => {
                                            setWrapperLoaded(true);
                                        }}
                                        title="Personalized Gift Wrapper"
                                        src={pickWrapper}
                                        style={{width: '100%', height: '100%'}}
                                    />
                                </span>
                            </div>
                        </div>
                        <div
                            className={clsx('peel-back', {
                                [classes.peelBackHidden]:
                                    !props.pickImage && !props.icon,
                            })}
                        />
                        <div
                            className={clsx('peel-bottom', {
                                [classes.peelBottomHidden]:
                                    !props.pickImage && !props.icon,
                                [classes.peelBottomShadowHidden]:
                                    !props.pickWrapper,
                            })}>
                            {props.icon && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '60%',
                                        transform: 'translate(-50%,-50%)',
                                    }}>
                                    {props.icon}
                                </div>
                            )}

                            {pickImageRef && (
                                <img
                                    ref={pickImageRef}
                                    className="pick__image"
                                    alt=""
                                    title=""
                                    src={pickImage}
                                    onClick={handlePickImageClick}
                                    style={{
                                        zIndex: 2,
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        ...(!handleUnsizedPickImage && {
                                            width: '100%',
                                        }),
                                        ...(!handleUnsizedPickImage && {
                                            height: '100%',
                                        }),
                                        ...(handleUnsizedPickImage &&
                                            resizePickImageMaxDimension ===
                                                'maxWidth' && {
                                                maxWidth: '100%',
                                                width: 'auto',
                                                height: 'auto',
                                            }),
                                        ...(handleUnsizedPickImage &&
                                            resizePickImageMaxDimension ===
                                                'maxHeight' && {
                                                maxHeight: '100%',
                                                width: 'auto',
                                                height: 'auto',
                                            }),
                                    }}
                                />
                            )}

                            {!pickImageRef && (
                                <LazyImage
                                    ref={pickImageRef}
                                    className="pick__image"
                                    alt=""
                                    title=""
                                    src={pickImage}
                                    onClick={handlePickImageClick}
                                    style={{
                                        zIndex: 2,
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        ...(!handleUnsizedPickImage && {
                                            width: '100%',
                                        }),
                                        ...(!handleUnsizedPickImage && {
                                            height: '100%',
                                        }),
                                        ...(handleUnsizedPickImage &&
                                            resizePickImageMaxDimension ===
                                                'maxWidth' && {
                                                maxWidth: '100%',
                                                width: 'auto',
                                                height: 'auto',
                                            }),
                                        ...(handleUnsizedPickImage &&
                                            resizePickImageMaxDimension ===
                                                'maxHeight' && {
                                                maxHeight: '100%',
                                                width: 'auto',
                                                height: 'auto',
                                            }),
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ReactResizeDetector>
    );
};

Pick.defaultProps = {
    darkBackground: false,
    pickWrapper: false,
    pickImage: false,
};

export default Pick;
